import { h, Component } from 'preact';
import Recaptcha from 'components/bolt/forms/recaptcha/recaptcha';
import Field from 'components/bolt/forms/field/field';
import { joinClasses, parseDate } from 'utils/utils';
import s from 'components/bolt/forms/form/form.sss';
import { smoothScrollTo } from 'utils/smoothScroll';

export default class Form extends Component {
	constructor(props) {
		super(props);
		this.validateAll = this.validateAll.bind(this);
		this.renderHiddenFields = this.renderHiddenFields.bind(this);
		this.renderCaptcha = this.renderCaptcha.bind(this);
		this.renderCustomInput = this.renderCustomInput.bind(this);
		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.state = {};
	}

	validateAll() {
		const { currentStage } = this.props;
		const fields = this.getFieldObjects();

		const currentStageFields = fields.filter(field => field.stage === currentStage);

		currentStageFields.forEach(field => {
			const { id } = field;
			if (!id) return;

			const elem = this[`$${id}`];

			if (field.type === 'input' || field.type === 'textarea') {
				elem && elem.validateInput();
			} else if (field.type === 'select') {
				elem && elem.validateSelect();
			} else if (field.type === 'timepicker') {
				elem && elem.validateTimepicker();
			}
		});
	}

	validateCaptcha = () => {
		if (this.$captcha) {
			this.$captcha.validateInput();
		}
	}

	onRecaptchaSuccess= () => this.props.onChange('captcha', true)
	onRecaptchaFailed= () => this.props.onChange('captcha', '')
	onRecaptchaLoad = () => this.props.onChange('captcha', '')
	// onRecaptchaUnmount= this.onRecaptchaFailed()
	getFieldObjects = () => {
		const { fields, data } = this.props;
		return fields.map(field => {
			const { stage, id, placeholder, validation } = field;
			const selectOptions = field.selectOptions ? field.selectOptions.split(',').map(item => item.trim()) : undefined;
			const renderCondition = () => {

				if (!field.renderCondition) {
					return undefined;
				}

				return field.renderCondition.split(',').map(item => data[item.trim()]).every(item => {
					if (!item) return;

					if (item.hour || item.minute || item.meridian) {
						return this.props.isValidTime(item);
					} else {
						return item;
					}
				});
			};

			return {
				stage: stage,
				id: id,
				name: field.name,
				type: field.type,
				renderCondition: renderCondition() === undefined ? true : renderCondition(),
				...(field.flexBasis && { flexBasis: `calc(${field.flexBasis} - 10px)` }),
				...(field.flexWidth && { flexWidth: field.flexWidth }),
				hasLabel: field.hasLabel,
				...(field.notes && { notes: field.notes }),
				...(field.hidden && { hidden: field.hidden }),
				...(!field.hidden && {
					label: field.label || placeholder,
					placeholder: placeholder || '',
					overwritePlaceholder: field.overwritePlaceholder || '',
					regex: validation.regex,
					validationMessage: validation.message,
					...(field.type === 'select' && { options: selectOptions || [`Please add the select options for field id: ${id}`] }),
					...(field.type === 'timepicker' && {
						nameHour: field.nameHour,
						nameMinutes: field.nameMinutes,
						nameMeridian: field.nameMeridian
					}),
					...(field.required && { required: true }),
				})
			};
		});
	};
	renderFormFields = (fields) => {
		const { onChange, formId, data, currentStage } = this.props;

		return fields.map(field => {
			const { stage, id, name, type, required, label, regex, validationMessage, renderCondition, hasLabel } = field;
			const notes = field?.notes;
			const outerStyle = stage === currentStage ? s.visible : s.hidden;
			const flexBasis = field?.flexBasis;
			const flexWidth = field?.flexWidth;
			const placeholder = field?.placeholder || label ;
			const options = field?.options;
			const nameHour = field?.nameHour;
			const nameMeridian = field?.nameMeridian;
			const nameMinutes = field?.nameMinutes;

			return (
				<div
					className={joinClasses(hasLabel && s.withLabelField, flexWidth && s.flexWidth)}
					style={{ flexBasis: flexBasis ? flexBasis : '' }}
				>
					{renderCondition && hasLabel && <Field type="paragraph" label={label} labelAlike wrapperClass={outerStyle} />}
					{renderCondition && (
						<Field
							formId={formId}
							ref={e => this[`$${id}`] = e}
							id={id}
							name={name}
							value={data[id]}
							type={type}
							options={options}
							label={label}
							placeholder={placeholder}
							// onKeyDown={onChange}
							onInput={onChange}
							nameHour={nameHour}
							nameMinutes={nameMinutes}
							nameMeridian={nameMeridian}
							regex={regex}
							validationMessage={validationMessage}
							notes={notes}
							wrapperClass={outerStyle}
							required={required}
						/>
					)}
				</div>
			);
		});
	};
	renderCaptcha() {
		return (
			<Recaptcha
				type="v2-tickbox"
				siteKey={this.props.recaptchaKey}
				onSuccess={this.onRecaptchaSuccess}
				onFailed={this.onRecaptchaFailed}
				onLoad={this.onRecaptchaLoad}
				onUnmount={this.onRecaptchaFailed}
			/>
		);
	}
	renderCustomInput() {}
	renderConfirmationFields = (fields) => {
		const { data, currentStage, hasRecaptcha, formId } = this.props;
		const date = parseDate(this.props.data.formDate);

		// const LockIcon = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><path fill="currentColor" d="M24 14h-2V8a6 6 0 0 0-12 0v6H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2ZM12 8a4 4 0 0 1 8 0v6h-8Zm12 20H8V16h16Z" /></svg>;

		const paragraphFields = fields
			.filter(field => (field.id !== 'formDate' && field.id !== 'date') && data[field.id])
			.map(field => {
				const value = data[field.id];
				const fieldValue = (field.type === 'timepicker' && value) ? `${value?.hour}:${value?.minute} ${value?.meridian}` : value;
				const flexBasis = field?.flexBasis;
				const flexWidth = field?.flexWidth;
				const hasLabel = field?.hasLabel;
				// const outerStyle = stage === currentStage ? s.visible : s.hidden;

				const fieldElem = <Field type="paragraph" value={fieldValue || 'N/A'} wrapperClass={s.notEditableField} plainText />;

				return 		(
					<div
						className={joinClasses(hasLabel && s.withLabelField, flexWidth && s.flexWidth)}
						style={{ flexBasis: flexBasis ? flexBasis : '', marginTop: '0' }}
					>
						{hasLabel && <Field type="paragraph" label={field.label} labelAlike />}
						{fieldElem}
					</div>
				);
			});

		return (
			<div className={currentStage === this.props.finalStage ? s.visibleFormFields : s.hiddenFormFields}>
				<div className={s.withLabelField}>
					<Field type="paragraph" label="Date*" labelAlike />
					<Field type="paragraph" value={new Intl.DateTimeFormat('en-US', { dateStyle: 'full' }).format(date)} wrapperClass={s.notEditableField} plainText />
				</div>

				{paragraphFields}
				{this.renderCustomInput()}
				{(hasRecaptcha && currentStage === this.props.finalStage && (formId === 'amc-theatres' ? this.shouldRenderCaptcha : true)) && this.renderCaptcha()}
			</div>

		);
	}

	componentWillUnmount() {
		this.props.onChange('captcha', '');
	}

	renderHiddenFields() {
		const date = parseDate(this.props.data.formDate);
		const { selectedTheaterName, movieTitle } = this.props;
		return (
			<div id="hidden-fields">
				<input type="hidden" name="Theatre" value={selectedTheaterName} />
				<input type="hidden" name="Date" value={new Intl.DateTimeFormat('en-US').format(new Date(date))} />
				<input type="hidden" name="Movie" value={movieTitle} />
				<input type="hidden" name="SourceName" value="Powster" />
			</div>
		);

	}

	componentDidUpdate(prevProps, prevState) {
		const { formId, currentStage } = this.props;
		if (currentStage && currentStage !== prevProps.currentStage) {
			const form = document.querySelector(`#${formId}`);
			smoothScrollTo(form);

			// also clear the previous markings when navigating through stages
			const fields = this.getFieldObjects();
			const prevStageFields = fields.filter(field => field.stage === prevProps.currentStage);
			prevStageFields.forEach(field => {
				const { id } = field;
				if (!id) return;
				const elem = this[`$${id}`];
				if (elem && elem.$element) {
					elem.clearClues(elem.$element);
				}
			});
		}
	}

	onFormSubmit(e) {
		if (!this.props.htmlSubmit) {
			e.preventDefault();
			return;
		}
		// Assume the form was correctly submitted
		this.props.setFormSubmitted?.();
	}

	render() {
		const { formId, currentStage, htmlSubmit, submitUrl, submitToNewTab } = this.props;
		const fields = this.getFieldObjects();
		let target;
		if (htmlSubmit && submitToNewTab) {
			target = '_blank';
		}

		return (
			<form
				id={formId}
				className={s.groupBookingForm}
				acceptCharset="utf-8"
				autoComplete="on"
				noValidate="true"
				action={htmlSubmit && submitUrl}
				method={htmlSubmit && 'POST'}
				target={target}
				onSubmit={this.onFormSubmit}
			>
				{this.renderHiddenFields()}
				{/* Doing this so all the fields are present during all stages, including Submit */}
				<div ref={e => this.$formFieldsContainer = e} className={currentStage === this.props.finalStage ? s.hiddenFormFields : s.visibleFormFields}>
					{this.renderFormFields(fields)}
				</div>

				{this.renderConfirmationFields(fields)}
			</form>
		);
	}
}
